import { RollbackOutlined } from "@ant-design/icons"
import { Button, Divider, Drawer, Image, Input, Space, Typography, message } from "antd"
import { doc, updateDoc } from "firebase/firestore"
import React, { useState } from "react"
import { db } from "../../../firebase/config"
import moment from "moment/moment"

const { TextArea } = Input
const { Link, Text } = Typography

export default function RequestNewTechnical({ record }) {
  const [open, setOpen] = useState(false)
  const [technicalPageRequestComment, setTechnicalPageRequestComment] = useState("")

  const showDrawer = () => {
    setOpen(true)
  }

  const onClose = () => {
    setOpen(false)
  }

  //function for requesting a new technical page

  const requestNewTechnical = async () => {
    // docref
    const docref = doc(db, "priceCalculation", record.id)

    // prev technicals
    let prevTechnicals
    const newTechnicalObject = {
      link: record.technicalPage,
      date: moment().toISOString(), // Using moment.js to create an ISO timestamp
      comment: technicalPageRequestComment,
    }

    if (record.updateForTechnical) {
      prevTechnicals = record.previousTechnicalPages
      prevTechnicals = [...prevTechnicals, newTechnicalObject]
    } else {
      prevTechnicals = [newTechnicalObject]
    }

    try {
      await updateDoc(docref, {
        previousTechnicalPages: prevTechnicals,
        updateForTechnical: true,
        technicalPageComment: technicalPageRequestComment,
        hasTechincalPage: 1,
        technicalPage: null,
      })
    } catch (error) {
      console.log(error)
      message.error("Something went wrong, check the console!")
    } finally {
      message.success("Requested!")
      onClose()
    }
  }

  //does it has previous technical pages?
  const doesPreviousExist = () => {
    if (record.updateForTechnical) {
      return (
        <>
          <Divider>Previous technical pages</Divider>
          {record.previousTechnicalPages.map((item, index) => (
            <div key={index}>
              <Space split={<Divider type="vertical" />}>
                <Link href={item.link} target="_blank">
                  Link
                </Link>
                <Text>{moment(item.date).format("MMMM Do YYYY, h:mm:ss a")}</Text>
              </Space>
            </div>
          ))}
          <Divider>Comment from user</Divider>
          <TextArea readOnly rows={8} value={record.technicalPageComment} />
        </>
      )
    }
  }

  return (
    <>
      <RollbackOutlined onClick={showDrawer} />
      <Drawer
        title={`Technical Request for "${record.client}"`}
        width={500}
        placement="right"
        onClose={onClose}
        open={open}>
        <Divider>Current Technical Page</Divider>
        <Image width="100%" src={record.technicalPage} />

        {doesPreviousExist()}

        <Divider>Comment on requesting new one</Divider>
        <Space style={{ width: "100%" }} direction="vertical">
          <TextArea
            rows={8}
            value={technicalPageRequestComment}
            onChange={(event) => setTechnicalPageRequestComment(event.target.value)}
          />
          <Button onClick={requestNewTechnical} block type="primary" icon={<RollbackOutlined />}>
            Request a new one!
          </Button>
        </Space>
      </Drawer>
    </>
  )
}
